



















import Vue from 'vue'
import Component from 'vue-class-component'
// import { Getter } from 'vuex-class'

// import { Prop } from 'vue-property-decorator'

// const namespace = 'digitalCurrency'

@Component({
  components: {
    //
  }
})
class DigitalCurrencyTransaction5TransactionSettingsIntroduction extends Vue {

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }
}

export default DigitalCurrencyTransaction5TransactionSettingsIntroduction


